import Header from "../../../layouts/AuthLayout/header/header";
import PersonalizedUsersSection from "./personalized-users-section";

export default function PersonalizedUsersPage() {
  return (
    <>
      <Header />
      <PersonalizedUsersSection />
    </>
  );
}
